import Vue from 'vue';
import VueCalendly from 'vue-calendly';

Vue.use(VueCalendly);
